var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('b-loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }